import { useState } from 'react';
export const useUploadProgress = () => {
    const [progress, setProgress] = useState(0);
    const onUploadProgressChange = ({ loaded, total }) => {
        const newProgress = Math.round((100 * loaded) / total);
        setProgress(newProgress);
    };
    return { progress, onUploadProgressChange };
};
